/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgSwitch: React.FC<React.SVGAttributes<SVGElement>> = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M15.19 13.009c.146-.526.784-.684 1.176-.286l3.419 3.513a.72.72 0 01-.002 1.028l-.759.776-2.641 2.72c-.197.203-.429.287-.7.215-.534-.142-.698-.799-.302-1.21l2.097-2.164c.034-.035.08-.062.092-.12-.052-.03-.107-.015-.16-.015H4.75l-.082-.002a.718.718 0 01-.275-1.354.824.824 0 01.391-.078h12.629c.052 0 .107.01.173-.018l-.11-.12-2.088-2.153c-.2-.205-.276-.45-.197-.732zm-6.38-9.5c.078.283.002.527-.198.732L6.524 6.395l-.11.119c.066.028.12.018.173.018h12.629c.136 0 .268.014.391.078a.717.717 0 01-.274 1.354l-.083.002H6.59c-.053 0-.108-.015-.16.015.011.058.058.085.092.12l2.097 2.164c.396.411.232 1.068-.302 1.21-.271.072-.503-.012-.7-.215L4.976 8.54l-.76-.776a.719.719 0 010-1.028l3.418-3.513c.392-.398 1.03-.24 1.175.286z"
            />
            <path d="M0 0h24v24H0z" />
        </g>
    </svg>
);
